// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/security-resilience-img/security_resilience_herobg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/security-resilience-img/security_resilience_herobg_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/security-resilience-img/commitment_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/images/security-resilience-img/commitment_bg_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../public/images/security-resilience-img/rules_engagementbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../public/images/security-resilience-img/reportingbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../public/images/security-resilience-img/reportingbg_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../public/images/security-resilience-img/rewards_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../public/images/security-resilience-img/rewards_bg_light.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AGCX Security & Resilience / Bug Bounty Page CSS */

.bugbounty_page {
  width: 100%;
  min-height: 100vh;
  background-color: #171A20;
  color: #ffffff;
  padding-bottom: 80px;
  font-family: inherit;
}

body.light_theme .bugbounty_page {
  background-color: #f8f9fa;
  color: #111827;
}

/* Global Section Title & Subtitle Styling */
.sec_title {
  font-size: 74px;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 12px;
  line-height: 1.25;
}

body.light_theme .sec_title {
  color: #111827;
}

.sec_title .gold_text {
  background: #D1AA67;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

body.light_theme .sec_title .gold_text {
  background: #D1AA67;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-text-fill-color: transparent;
}

.sec_subtitle {
  font-size: 24px;
  color: #CBD5E1;
  max-width: 60%;
  line-height: 1.6;
  font-weight: 300;
  margin-bottom: 32px;
}

body.light_theme .sec_subtitle {
  color: #4b5563;
}

/* 1. Hero Section */
.security_resilience_hero_sec {
  width: 100%;
  padding-top: 130px;
  padding-bottom: 10px;
  background-size: cover;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: top center;
  background-repeat: no-repeat;
  text-align: center;
}

body.light_theme .security_resilience_hero_sec {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-color: #ffffff;
}

.security_resilience_hero_sec .sec_subtitle {
  margin-left: auto;
  font-size: 26px;
  margin-right: auto;
  color: #9CA3AF;
  max-width: 1180px;
  font-weight: 300;
  padding-top: 10px;
}

.hero_img_wrap {
  margin-top: -95px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.herobnr_btn button {
  font-size: 18px;
  color: #E5E7EB;
  padding: 17px 32px;
  border-radius: 50px;
  background-color: rgb(82 82 82 / 90%);
  border: 1px solid rgb(255 255 255 / 12%);
}

.herobnr_btn {
  justify-content: center;
  gap: 24px;
  position: relative;
}

.herobnr_btn button.reportbtn {
  background-color: #D1AA67;
  border-color: #D1AA67;
}

.hero_img_wrap img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* 2. Our Commitment Section */
.our_commitment_sec {
  padding: 30px 0 12px;
  background-size: cover;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center;
  background-repeat: no-repeat;
}

.our_commitment_sec .sec_title {
  font-size: 70px;
  font-weight: 600;
}

.sec_subtitle .sec_subtitle {
  max-width: 70%;
}

body.light_theme .our_commitment_sec {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-color: #fff;
}

.commitment_text {
  font-size: 26px;
  color: #9CA3AF;
  line-height: 1.7;
  max-width: 800px;
}

body.light_theme .commitment_text {
  color: #374151;
}

.commitment_img_wrap {
  text-align: center;
}

.commitment_img_wrap img {
  max-width: 100%;
  max-height: 580px;
  object-fit: contain;
}

/* 3. Scope Section */
.scope_sec {
  padding: 90px 0;
}

.sec_title.h2titlesope {
  font-size: 60px;
  font-weight: 600;
}

.scope_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 42px;
  padding-top: 5px;
}

.scope_card::before {
  width: 229px;
  height: 229px;
  position: absolute;
  bottom: -40px;
  right: -40px;
  content: "";
  background-color: rgb(179 179 179 / 24%);
  border-radius: 100px;
  filter: blur(100px);
}

.scope_card.inscope::before {
  background-color: rgb(209 170 103 / 24%);
}

.scope_card {
  background: #1D1D1D;
  -webkit-backdrop-filter: blur(5px);
  overflow: hidden;
  position: relative;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 20px;
  padding: 42px;
}

.scope_card.inscope {
  background: #1E1E1E;
  border: 1px solid rgb(209 170 103 / 28%);
}

body.light_theme .scope_card {
  background: #F3F3F3;
  border-color: #d7d7d7;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
}

.scope_card_header {
  display: flex;
  align-items: start;
  gap: 26px;
  margin-bottom: 4px;
}

.scope_icon_badge {
  width: 84px;
  height: 84px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  font-weight: 600;
}

.scope_icon_badge.in_scope {
  background: #423A2D;
  color: #D1AA67;
  border: 3px solid #D1AA67;
  box-shadow: 0px 0px 22px rgb(209 170 103 / 50%);
}

.scope_icon_badge.out_scope {
  background: #1D1D1D;
  color: #999999;
  border: 3px solid #999999;
  box-shadow: 0px 0px 22px rgb(84 84 84 / 50%);
}

.scope_card_title {
  font-size: 34px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.scope_card.inscope h3 span {
  color: #D1AA67;
}

body.light_theme .scope_card_title {
  color: #111827;
}

.scope_list {
  list-style: none;
  padding: 0;
  margin: 14px 0px 0px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-left: 0px;
  position: relative;
}

.scope_list li::before {
  position: absolute;
  left: 0px;
  top: 50%;
  background-color: #999999;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  box-shadow: 0px 0px 10px #B3B3B3;
  border-radius: 50%;
  content: "";
  border: 1px solid #999999;
}

.scope_card.inscope .scope_list li::before {
  border-color: #D1AA67;
  background-color: #D1AA67;
  box-shadow: 0px 0px 10px #D1AA67;
}

.scope_list li {
  display: flex;
  align-items: center;
  position: relative;
  gap: 12px;
  font-weight: 300;
  font-size: 20px;
  color: #E2E8F0;
  padding-left: 32px;
}

body.light_theme .scope_list li {
  color: #101010;
}

body.light_theme .scope_icon_badge.in_scope {
  background: rgb(219 134 0 / 10%);
}

body.light_theme .scope_icon_badge.out_scope {
  background: rgb(29 29 29 / 15%);
}

.scope_list li i {
  font-size: 16px;
}

.scope_list li i.in_check {
  color: #D1AA67;
}

.scope_list li i.out_cross {
  color: #64748b;
}

/* 4. Qualifying Issues Section */
.qualifying_issues_sec {
  padding: 20px 0;
}

.qualifying_issues_sec .sec_subtitle {
  max-width: 100%;
}

.qualifying_grid {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.qualifying_card {
  width: 59%;
  background: rgba(255, 255, 255, 0.03);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 150px;
  transition: all 0.3s ease;
}

.qualifying_card.activeeffect {
  width: 39%;
  background: linear-gradient(90deg, rgba(34, 36, 39, 1) 0%, rgba(82, 73, 56, 1) 170%);
}

body.light_theme .qualifying_card {
  background: rgb(0 0 0 / 5%);
  border-color: #d7d7d7;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
}

body.light_theme .qualifying_card.activeeffect {
  background: linear-gradient(90deg, rgb(0 0 0 / 5%) 0%, rgb(209 170 103 / 30%) 170%);
  border-color: #f3d4d4;
}

.qualifying_card:hover {
  border-color: rgba(209, 170, 103, 0.4);
  transform: translateY(-2px);
}

.qualifying_card_top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.qualifying_card_subtext {
  font-size: 21px;
  color: #D9D9D9;
  line-height: 1.5;
  font-weight: 300;
  margin-bottom: 0;
  max-width: 70%;
}

body.light_theme .qualifying_card_subtext {
  color: #3c3c3c;
}

body.light_theme .qualifying_check_icon {
  color: #080808;
}

.qualifying_check_icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #D1AA67;
  border: 1px solid #D1AA67;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  min-width: 60px;
}

.qualifying_card_title {
  font-size: 40px;
  font-weight: 300;
  color: #ffffff;
  margin-top: 50px;
  margin-bottom: 20px;
}

body.light_theme .qualifying_card_title {
  color: #111827;
}

/* 5. Rules of Engagement Section */
.rules_of_engagement_sec {
  padding: 110px 0;
  background-size: cover;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center;
  background-repeat: no-repeat;
}

body.light_theme .rules_of_engagement_sec {
  background-image: none;
  background-color: #f3f4f6;
}

.rules_grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.rewards_sec .commitment_text {
  line-height: 1.3;
}

.rule_pill_card {
  background: rgba(255, 255, 255, 0.05);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 100px;
  cursor: pointer;
  padding: 32px 60px;
  font-size: 22px;
  box-shadow: inset 0px 3px 12px rgb(0 0 0 / 30%);
  color: #E5E7EB;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
}

body.light_theme .rule_pill_card {
  background: rgb(0 0 0 / 5%);
  border-color: #cdcdcd;
  color: #1f2937;
  box-shadow: inset 0px 3px 12px rgb(0 0 0 / 10%);
}

.rule_pill_card:hover {
  border-color: rgba(209, 170, 103, 0.5);
  color: #D1AA67;
}

/* 6. Responsible Disclosure & Reporting Section */
.responsible_disclosure_sec {
  padding: 90px 0;
  text-align: center;
  background-size: cover;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: center;
  background-repeat: no-repeat;
}

body.light_theme .responsible_disclosure_sec {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.disclosure_info.listinfo_bl {
  gap: 48px;
  border-left: 1px solid rgb(255 255 255 / 40%);
  border-right: 1px solid rgb(255 255 255 / 40%);
  padding-left: 32px;
  padding-right: 32px;
}

.disclosure_list ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.disclosure_list ul li {
  font-size: 15px;
  color: #D1D5DB;
  position: relative;
  padding-left: 20px;
  font-weight: 300;
}

.disclosure_list ul li::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #D1AA67;
}

.reporting_steps_row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 32px;
  margin-top: 20px;
  margin-bottom: 60px;
  justify-content: center;
}

.reporting_step_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.reporting_icon_wrap {
  width: 180px;
  margin-bottom: 16px;
}

.reporting_icon_wrap img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.reporting_step_name {
  font-size: 24px;
  font-weight: 500;
  color: #e9e9e9;
  margin-bottom: 10px;
}

body.light_theme .reporting_step_name {
  color: #111827;
}

.reporting_step_desc {
  font-size: 15px;
  color: #d7d7d7;
  line-height: 1.5;
  max-width: 240px;
}

body.light_theme .reporting_step_desc {
  color: #6b7280;
}

.disclosure_banner {
  background: linear-gradient(160deg, rgb(209 170 103 / 20%) 0%, rgba(255, 255, 255, 0) 20%);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 20px;
  padding: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  box-shadow: inset 0px -7px 16px rgb(255 255 255 / 10%);
  gap: 20px;
}

body.light_theme .disclosure_banner {
  background: linear-gradient(160deg, rgb(209 170 103 / 20%) 0%, rgb(0 0 0 / 5%) 20%);
  border-color: #e5e7eb;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
}

body.light_theme .disclosure_info h4 a {
  color: #303030;
}

body.light_theme .disclosure_list ul li {
  color: #181818;
}

body.light_theme .disclosure_btn {
  color: #000000;
}

.disclosure_info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.disclosure_info_icon {
  width: 62px;
  min-width: 62px;
  height: 62px;
  border-radius: 50%;
  background: rgba(209, 170, 103, 0.15);
  border: 1px solid rgba(209, 170, 103, 0.4);
  color: #D1AA67;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.disclosure_info h4 {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 4px;
}

.disclosure_info h4 a {
  color: #fff;
}

.disclosure_info h4 span {
  color: #D1AA67;
}

body.light_theme .disclosure_info h4 {
  color: #111827;
}

.disclosure_info p {
  font-size: 15px;
  color: #9CA3AF;
  text-align: left;
  margin: 0;
  line-height: 1.5;
}

.disclosure_info.leftinfo_disclosure {
  width: 440px;
  max-width: 100%;
}

body.light_theme .disclosure_info p {
  color: #6b7280;
}

.disclosure_btn {
  background: #D1AA67;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  padding: 15px 32px;
  box-shadow: 0px 0px 24px rgb(209 170 103 / 50%);
  border-radius: 30px;
  text-decoration: none;
  display: inline-block;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.disclosure_btn:hover {
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(209, 170, 103, 0.5);
}

/* 7. What Happens Next Section */
.what_happens_next_sec {
  padding: 50px 0;
  text-align: center;
}

.what_happens_next_sec .sec_subtitle {
  color: #9CA3AF;
  max-width: 80%;
}

.what_next_grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 18px;
  margin-top: 40px;
}

.next_card {
  background: none;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border: 1px solid #514F4F;
  position: relative;
  border-radius: 28px;
  padding: 14px;
  text-align: center;
  transition: all 0.3s ease;
}

.happens_cardcnt {
  position: absolute;
  top: 58px;
  width: 100%;
  left: 0px;
}

body.light_theme .next_card {
  background: #ffffff;
  border-color: #cfcfcf;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
}

.next_card:hover {
  border-color: rgba(209, 170, 103, 0.4);
  transform: translateY(-4px);
}

.next_card_icon {
  width: 124px;
  margin: 0 auto 36px auto;
}

.next_card_icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.next_card_title {
  font-size: 24px;
  font-weight: 500;
  color: #ffffff;
  background: linear-gradient(180deg, #fff 20%, rgb(255 255 255 / 0) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 6px;
}

body.light_theme .next_card_title {
  background: linear-gradient(180deg, #000000 20%, rgb(26 26 26 / 45%) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.next_card_desc {
  font-size: 14px;
  font-weight: 300;
  color: rgb(217 217 217 / 50%);
  line-height: 1.5;
  margin: 0;
  max-width: 80%;
  margin: 0 auto;
}

body.light_theme .next_card_desc {
  color: #6b7280;
}

/* 8. Rewards Section */
.rewards_sec {
  padding: 110px 0;
  position: relative;
  background-size: cover;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: center;
  background-repeat: no-repeat;
}

.rewards_sec::before {
  width: 100%;
  height: 150px;
  content: "";
  position: absolute;
  bottom: 0px;
  background: linear-gradient(0deg, rgb(23 26 32) 0%, rgba(255, 255, 255, 0) 100%);
  z-index: 1;
}

.rewards_sec .container {
  position: relative;
  z-index: 222;
}

body.light_theme .rewards_sec {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-color: #ffffff;
}

body.light_theme .rewards_sec::before {
  background: linear-gradient(0deg, rgb(255 255 255) 0%, rgba(255, 255, 255, 0) 100%);
}

.rewards_callout_box {
  background: rgb(255 255 255 / 15%);
  border: 1px solid rgb(255 255 255 / 30%);
  border-radius: 50px;
  padding: 16px 20px;
  margin-top: 24px;
  font-weight: 300;
  font-size: 20px;
  color: #fff;
  line-height: 1.5;
  display: flex;
  align-items: start;
  gap: 12px;
}

.rewards_callout_box .ri-information-fill:before {
  color: #897c47;
  font-size: 22px;
}

body.light_theme .rewards_callout_box {
  background: rgb(0 0 0 / 12%);
  color: #000000;
}

.rewards_card {
  margin-left: 18px;
  background: rgba(255, 255, 255, 0.10);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.20);
  border-radius: 16px;
  padding: 0px;
}

body.light_theme .rewards_callout_box .ri-information-fill:before {
  color: #bbb087;
}

body.light_theme .rewards_card {
  background: rgb(255 255 255 / 10%);
  border-color: #e5e7eb;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10);
}

body.light_theme .reward_val {
  color: #000000;
}

.reward_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 26px;
  border-bottom: 1px solid rgb(255 255 255 / 10%);
}

body.light_theme .reward_row {
  border-bottom-color: #cfcfcf;
}

.reward_row:last-child {
  border-bottom: none;
}

.reward_level {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 12px;
}

.rangelevel span {
  font-size: 14px;
  color: #9CA3AF;
}

.reward_level i {
  font-size: 12px;
  color: #10B981;
}

.reward_level i.critical:before {
  color: #EF4444;
}

.reward_level i.high:before {
  color: #F59E0B;
}

.reward_level i.medium:before {
  color: #D1AA67;
}

.reward_level i.information:before {
  color: #9CA3AF;
}

body.light_theme .reward_level {
  color: #111827;
}

.reward_val {
  font-size: 16px;
  font-weight: 300;
  color: #E5E7EB;
}

span.reward_val.dangercolor {
  color: #d1aa67;
}

/* 9. Safe Harbor Section */
.safe_harbor_sec {
  padding: 90px 0;
}

.safe_harbor_main_card {
  background: rgba(255, 255, 255, 0.05);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  padding: 32px;
  display: grid;
  grid-template-columns: 1fr 440px;
  gap: 40px;
  align-items: center;
  margin-bottom: 60px;
  box-shadow: inset 0 6px 20px rgb(0 0 0 / 20%);
}

.safe_harbor_main_card::before {
  width: 384px;
  height: 384px;
  position: absolute;
  content: "";
  top: -110px;
  right: -70px;
  background: rgb(209 170 103 / 10%);
  border-radius: 100%;
  filter: blur(30px);
}

body.light_theme .safe_harbor_main_card {
  background: rgb(0 0 0 / 5%);
  border-color: #e5e7eb;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
}

/* .safe_harbor_title {
  color: #ffffff;
  margin-bottom: 15px;
  line-height: 1.15;
} */

body.light_theme .safe_harbor_title {
  color: #111827;
}

.safe_harbor_desc {
  font-size: 24px;
  color: #9CA3AF;
  line-height: 1.40;
  margin: 0;
  font-weight: 300;
}

body.light_theme .safe_harbor_desc {
  color: #4b5563;
}

.safe_harbor_notice_card {
  background: rgba(255, 255, 255, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.12);
  position: relative;
  z-index: 222;
  border-radius: 16px;
  padding: 18px;
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

body.light_theme .safe_harbor_notice_card {
  background: rgba(0, 0, 0, 0.10);
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.safe_notice_icon {
  color: #D1AA67;
  font-size: 20px;
}

.safe_notice_text {
  font-size: 14px;
  color: #CBD5E1;
  line-height: 1.55;
  margin: 0;
  font-weight: 300;
}

body.light_theme .safe_notice_text {
  color: #6b7280;
}

.safe_harbor_bottom_grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  padding-top: 20px;
}

.safe_mini_card {
  background: rgba(255, 255, 255, 0.10);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 24px;
  display: flex;
  box-shadow: inset 0 6px 20px rgb(0 0 0 / 25%);
  align-items: center;
  gap: 18px;
}

body.light_theme .safe_mini_card {
  background: rgb(0 0 0 / 5%);
  border-color: #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.safe_mini_icon {
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 50%;
  border: 1px solid rgb(212 175 55 / 40%);
  /* background: rgba(209, 170, 103, 0.05); */
  box-shadow: 0px 0px 14px rgb(212 175 55 / 25%);
  color: #F5D77F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.safe_mini_content {
  display: flex;
  flex-direction: column;
}

.safe_mini_title {
  font-size: 17px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 6px 0;
  line-height: 1.3;
}

body.light_theme .safe_mini_title {
  color: #111827;
}

h4.safe_mini_title.questionshd {
  font-size: 21px;
}

.safe_mini_desc {
  font-size: 14px;
  color: #CBD5E1;
  line-height: 1.5;
  margin: 0;
  font-weight: 300;
}

body.light_theme .what_happens_next_sec {
  background-color: #fff;
}

body.light_theme .safe_mini_desc {
  color: #000;
}

body.light_theme .safe_mini_icon {
  color: #d1aa67;
}

.safe_harbor_left {
  position: relative;
  z-index: 222;
}

@media (max-width: 1640px) {

  .sec_title {
    font-size: 62px;
  }

  .our_commitment_sec .sec_title {
    font-size: 60px;
  }

}

@media (max-width: 1440px) {

  .sec_title {
    font-size: 54px;
  }

  .happens_cardcnt {
    top: 48px;
  }

  .next_card_title {
    font-size: 21px;
  }

  .next_card_icon {
    width: 100px;
    margin: 0 auto 24px auto;
  }

  .our_commitment_sec .sec_title {
    font-size: 54px;
  }

  .commitment_text {
    font-size: 22px;
  }

  .sec_title.h2titlesope {
    font-size: 48px;
  }

  .sec_subtitle {
    font-size: 20px;
  }

  .qualifying_card_title {
    font-size: 36px;
  }

}

@media (max-width:1376px) {

  .sec_title {
    font-size: 48px;
  }

  .safe_harbor_desc {
    font-size: 18px;
  }

  .security_resilience_hero_sec .sec_subtitle {
    font-size: 20px;
  }

  .hero_img_wrap {
    margin-top: -65px;
  }

  .hero_img_wrap img {
    max-width: 80%;
  }

  .our_commitment_sec .sec_title {
    font-size: 42px;
  }

  .commitment_text {
    font-size: 18px;
  }

  .sec_title.h2titlesope {
    font-size: 40px;
  }

  .sec_subtitle {
    font-size: 18px;
  }

  .scope_card_title {
    font-size: 28px;
  }

  .scope_list li {
    font-size: 16px;
  }

  .qualifying_card_subtext {
    font-size: 16px;
  }

  .qualifying_card_title {
    font-size: 28px;
  }

  .qualifying_card {
    width: 58%;
  }

  .rule_pill_card {
    padding: 24px 42px;
    font-size: 18px;
  }

  .reporting_step_name {
    font-size: 20px;
  }

  .rewards_callout_box {
    font-size: 16px;
  }


}

/* Media Queries */
@media (max-width: 1200px) {


  .security_resilience_hero_sec {
    padding-top: 60px;
  }

  .herobnr_btn button {
    font-size: 15px;
    padding: 15px 32px;
  }

  .hero_img_wrap {
    margin-top: -35px;
  }

  .our_commitment_sec .sec_title {
    font-size: 32px;
  }

  .commitment_text {
    font-size: 16px;
  }

  .sec_subtitle {
    font-size: 16px;
  }

  .scope_card {
    padding: 32px;
  }

  .scope_icon_badge {
    width: 60px;
    height: 60px;
    min-width: 60px;
    font-size: 30px;
  }

  .qualifying_card_title {
    font-size: 24px;
  }

  .rule_pill_card {
    padding: 20px 36px;
    font-size: 16px;
  }

  .disclosure_info.leftinfo_disclosure {
    flex-direction: column;
    align-items: start;
  }

  .disclosure_btn {
    font-size: 15px;
    padding: 12px 28px;
  }


  .disclosure_info.listinfo_bl {
    gap: 32px;
    padding-left: 24px;
    padding-right: 24px;
  }

  .scope_sec {
    padding: 50px 0;
  }

  .rules_of_engagement_sec {
    padding: 60px 0;
  }

  .responsible_disclosure_sec {
    padding: 60px 0;
  }

  .rewards_sec {
    padding: 70px 0;
  }

  .reward_val {
    font-size: 15px;
    text-align: right;
  }

  .reward_level {
    font-size: 14px;
  }

  .sec_title.h2titlesope {
    font-size: 32px;
  }

  .sec_title {
    font-size: 34px;
  }

  .reporting_steps_row,
  .what_next_grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 991px) {

  .sec_title {
    font-size: 32px;
  }

  .security_resilience_hero_sec .sec_subtitle {
    font-size: 18px;
  }

  .hero_img_wrap {
    margin-top: -15px;
  }

  .our_commitment_sec .sec_title {
    font-size: 28px;
  }

  .commitment_text {
    font-size: 15px;
  }

  .sec_title.h2titlesope {
    font-size: 28px;
  }

  .sec_subtitle {
    font-size: 15px;
    max-width: 100%;
    margin-bottom: 20px;
  }

  .scope_grid,
  .qualifying_grid,
  .rules_grid,
  .safe_harbor_main_card {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .safe_harbor_bottom_grid {
    grid-template-columns: 1fr;
  }

  .disclosure_banner {
    flex-direction: column;
    text-align: center;
  }

  .disclosure_info {
    flex-direction: column;
    text-align: center;
  }

  .qualifying_card.activeeffect {
    width: 100%;
  }

  .qualifying_card {
    width: 100%;
  }

  .rules_of_engagement_sec {
    padding: 40px 0;
  }

  .responsible_disclosure_sec {
    padding: 40px 0;
  }

  .disclosure_info.leftinfo_disclosure {
    flex-direction: row;
    align-items: center;
  }

  .disclosure_info h4 {
    text-align: left;
  }

  .disclosure_info.leftinfo_disclosure {
    width: 100%;
  }

  .disclosure_info.listinfo_bl {
    gap: 12px;
    padding-left: 0px;
    padding-right: 0px;
    width: 100%;
    align-items: start;
    border: none;
  }

  .disclosure_list ul li {
    text-align: left;
  }

  .disclosure_banner {
    padding: 32px;
    align-items: start;
    text-align: left;
    gap: 32px;
  }

  .what_happens_next_sec {
    padding: 20px 0 40px;
  }

  .rewards_sec {
    padding: 40px 0;
  }

  .rewards_card {
    margin-left: 0px;
    margin-top: 15px;
  }

  .safe_harbor_sec {
    padding: 40px 0;
  }

  .safe_harbor_desc {
    font-size: 15px;
  }

}

@media (max-width: 767px) {

  .security_resilience_hero_sec {
    padding-top: 50px;
    padding-bottom: 0px;
  }

  .reporting_steps_row {
    margin-top: 0px;
    gap: 18px;
    margin-bottom: 30px;
  }

  h4.safe_mini_title.questionshd {
    font-size: 18px;
  }

  .bugbounty_page {
    padding-bottom: 20px;
  }

  .safe_harbor_main_card {
    margin-bottom: 18px;
  }

  .sec_title {
    font-size: 24px;
  }

  .security_resilience_hero_sec .sec_subtitle {
    font-size: 15px;
    padding-top: 0px;
  }

  .herobnr_btn button {
    font-size: 14px;
    padding: 10px 24px;
  }

  .herobnr_btn {
    gap: 15px;
  }

  .hero_img_wrap {
    margin-top: 0px;
  }

  .sec_subtitle {
    font-size: 14px;
  }

  .reporting_steps_row,
  .what_next_grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .hero_img_wrap img {
    max-width: 100%;
  }

  .our_commitment_sec .sec_title {
    font-size: 22px;
  }

  .commitment_img_wrap img {
    max-height: 280px;
  }

  .sec_title.h2titlesope {
    font-size: 22px;
  }

  .scope_sec {
    padding: 30px 0;
  }

  .scope_card {
    padding: 26px;
  }

  .scope_icon_badge {
    width: 42px;
    height: 42px;
    min-width: 42px;
    font-size: 22px;
  }

  .scope_icon_badge.in_scope {
    border: 1.7px solid #D1AA67;
  }

  .scope_card_title {
    font-size: 22px;
  }

  .scope_list li {
    font-size: 14px;
    padding-left: 24px;
  }

  .scope_icon_badge.out_scope {
    border: 1.7px solid #999999;
  }

  .qualifying_card_subtext {
    font-size: 15px;
  }

  .qualifying_card {
    padding: 22px;
  }

  .qualifying_card_title {
    font-size: 20px;
    margin-bottom: 0px;
  }

  .qualifying_check_icon {
    width: 36px;
    height: 36px;
    font-size: 17px;
    min-width: 36px;
  }

  .rule_pill_card {
    padding: 12px 24px;
    font-size: 15px;
  }

  .reporting_step_desc {
    max-width: 320px;
  }

  .disclosure_banner {
    padding: 22px;
  }

  .disclosure_info p {
    font-size: 13px;
  }

  .disclosure_info_icon {
    width: 42px;
    min-width: 42px;
    height: 42px;
    font-size: 15px;
  }

  .what_happens_next_sec .sec_subtitle {
    max-width: 100%;
  }

  .responsible_disclosure_sec {
    padding: 30px 0 24px;
  }

  .what_next_grid {
    margin-top: 28px;
  }

  .rewards_callout_box {
    font-size: 15px;
  }

  .reward_row {
    padding: 12px 18px;
  }

  .reward_val {
    font-size: 13px;
  }

  .safe_harbor_sec {
    padding: 20px 0;
  }

  .safe_harbor_main_card {
    padding: 24px;
  }


}

@media (max-width: 480px) {

  .reporting_steps_row,
  .what_next_grid {
    grid-template-columns: 1fr;
  }

  .herobnr_btn button {
    padding: 9px 18px;
  }


}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/BugBounty/bugBounty.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,yDAAuG;EACvG,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,yDAA6G;EAC7G,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,sBAAsB;EACtB,yDAA0F;EAC1F,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yDAAgG;EAChG,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,mCAA2B;UAA3B,2BAA2B;EAC3B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,oFAAoF;AACtF;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,mFAAmF;EACnF,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yDAA+F;EAC/F,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,0BAA0B;EAC1B,2CAA2C;EAC3C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,+CAA+C;EAC/C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,yDAAwF;EACxF,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yDAA8F;AAChG;;AAEA;EACE,SAAS;EACT,6CAA6C;EAC7C,8CAA8C;EAC9C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0FAA0F;EAC1F,kCAAkC;EAClC,wBAAwB;EACxB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,sDAAsD;EACtD,SAAS;AACX;;AAEA;EACE,mFAAmF;EACnF,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wEAAwE;EACxE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yDAAuF;EACvF,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,gFAAgF;EAChF,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yDAA6F;EAC7F,yBAAyB;AAC3B;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kCAAkC;EAClC,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,2BAA2B;EAC3B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;;;;GAIG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,2BAA2B;EAC3B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,6CAA6C;EAC7C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uCAAuC;EACvC,2CAA2C;EAC3C,8CAA8C;EAC9C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;AAGF;;AAEA,kBAAkB;AAClB;;;EAGE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;;EAGA;IACE,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,qCAAqC;EACvC;AACF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;;;;IAIE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;;AAGF;;AAEA;;EAEE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;;AAGF","sourcesContent":["/* AGCX Security & Resilience / Bug Bounty Page CSS */\n\n.bugbounty_page {\n  width: 100%;\n  min-height: 100vh;\n  background-color: #171A20;\n  color: #ffffff;\n  padding-bottom: 80px;\n  font-family: inherit;\n}\n\nbody.light_theme .bugbounty_page {\n  background-color: #f8f9fa;\n  color: #111827;\n}\n\n/* Global Section Title & Subtitle Styling */\n.sec_title {\n  font-size: 74px;\n  font-weight: 500;\n  color: #ffffff;\n  margin-bottom: 12px;\n  line-height: 1.25;\n}\n\nbody.light_theme .sec_title {\n  color: #111827;\n}\n\n.sec_title .gold_text {\n  background: #D1AA67;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\nbody.light_theme .sec_title .gold_text {\n  background: #D1AA67;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  -webkit-text-fill-color: transparent;\n}\n\n.sec_subtitle {\n  font-size: 24px;\n  color: #CBD5E1;\n  max-width: 60%;\n  line-height: 1.6;\n  font-weight: 300;\n  margin-bottom: 32px;\n}\n\nbody.light_theme .sec_subtitle {\n  color: #4b5563;\n}\n\n/* 1. Hero Section */\n.security_resilience_hero_sec {\n  width: 100%;\n  padding-top: 130px;\n  padding-bottom: 10px;\n  background-size: cover;\n  background-image: url(../../../../public/images/security-resilience-img/security_resilience_herobg.jpg);\n  background-position: top center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n\nbody.light_theme .security_resilience_hero_sec {\n  background-image: url(../../../../public/images/security-resilience-img/security_resilience_herobg_light.jpg);\n  background-color: #ffffff;\n}\n\n.security_resilience_hero_sec .sec_subtitle {\n  margin-left: auto;\n  font-size: 26px;\n  margin-right: auto;\n  color: #9CA3AF;\n  max-width: 1180px;\n  font-weight: 300;\n  padding-top: 10px;\n}\n\n.hero_img_wrap {\n  margin-top: -95px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.herobnr_btn button {\n  font-size: 18px;\n  color: #E5E7EB;\n  padding: 17px 32px;\n  border-radius: 50px;\n  background-color: rgb(82 82 82 / 90%);\n  border: 1px solid rgb(255 255 255 / 12%);\n}\n\n.herobnr_btn {\n  justify-content: center;\n  gap: 24px;\n  position: relative;\n}\n\n.herobnr_btn button.reportbtn {\n  background-color: #D1AA67;\n  border-color: #D1AA67;\n}\n\n.hero_img_wrap img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n/* 2. Our Commitment Section */\n.our_commitment_sec {\n  padding: 30px 0 12px;\n  background-size: cover;\n  background-image: url(../../../../public/images/security-resilience-img/commitment_bg.jpg);\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.our_commitment_sec .sec_title {\n  font-size: 70px;\n  font-weight: 600;\n}\n\n.sec_subtitle .sec_subtitle {\n  max-width: 70%;\n}\n\nbody.light_theme .our_commitment_sec {\n  background-image: url(../../../../public/images/security-resilience-img/commitment_bg_light.jpg);\n  background-color: #fff;\n}\n\n.commitment_text {\n  font-size: 26px;\n  color: #9CA3AF;\n  line-height: 1.7;\n  max-width: 800px;\n}\n\nbody.light_theme .commitment_text {\n  color: #374151;\n}\n\n.commitment_img_wrap {\n  text-align: center;\n}\n\n.commitment_img_wrap img {\n  max-width: 100%;\n  max-height: 580px;\n  object-fit: contain;\n}\n\n/* 3. Scope Section */\n.scope_sec {\n  padding: 90px 0;\n}\n\n.sec_title.h2titlesope {\n  font-size: 60px;\n  font-weight: 600;\n}\n\n.scope_grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 42px;\n  padding-top: 5px;\n}\n\n.scope_card::before {\n  width: 229px;\n  height: 229px;\n  position: absolute;\n  bottom: -40px;\n  right: -40px;\n  content: \"\";\n  background-color: rgb(179 179 179 / 24%);\n  border-radius: 100px;\n  filter: blur(100px);\n}\n\n.scope_card.inscope::before {\n  background-color: rgb(209 170 103 / 24%);\n}\n\n.scope_card {\n  background: #1D1D1D;\n  -webkit-backdrop-filter: blur(5px);\n  overflow: hidden;\n  position: relative;\n  backdrop-filter: blur(5px);\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 20px;\n  padding: 42px;\n}\n\n.scope_card.inscope {\n  background: #1E1E1E;\n  border: 1px solid rgb(209 170 103 / 28%);\n}\n\nbody.light_theme .scope_card {\n  background: #F3F3F3;\n  border-color: #d7d7d7;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);\n}\n\n.scope_card_header {\n  display: flex;\n  align-items: start;\n  gap: 26px;\n  margin-bottom: 4px;\n}\n\n.scope_icon_badge {\n  width: 84px;\n  height: 84px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 40px;\n  font-weight: 600;\n}\n\n.scope_icon_badge.in_scope {\n  background: #423A2D;\n  color: #D1AA67;\n  border: 3px solid #D1AA67;\n  box-shadow: 0px 0px 22px rgb(209 170 103 / 50%);\n}\n\n.scope_icon_badge.out_scope {\n  background: #1D1D1D;\n  color: #999999;\n  border: 3px solid #999999;\n  box-shadow: 0px 0px 22px rgb(84 84 84 / 50%);\n}\n\n.scope_card_title {\n  font-size: 34px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.scope_card.inscope h3 span {\n  color: #D1AA67;\n}\n\nbody.light_theme .scope_card_title {\n  color: #111827;\n}\n\n.scope_list {\n  list-style: none;\n  padding: 0;\n  margin: 14px 0px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-left: 0px;\n  position: relative;\n}\n\n.scope_list li::before {\n  position: absolute;\n  left: 0px;\n  top: 50%;\n  background-color: #999999;\n  transform: translateY(-50%);\n  width: 10px;\n  height: 10px;\n  box-shadow: 0px 0px 10px #B3B3B3;\n  border-radius: 50%;\n  content: \"\";\n  border: 1px solid #999999;\n}\n\n.scope_card.inscope .scope_list li::before {\n  border-color: #D1AA67;\n  background-color: #D1AA67;\n  box-shadow: 0px 0px 10px #D1AA67;\n}\n\n.scope_list li {\n  display: flex;\n  align-items: center;\n  position: relative;\n  gap: 12px;\n  font-weight: 300;\n  font-size: 20px;\n  color: #E2E8F0;\n  padding-left: 32px;\n}\n\nbody.light_theme .scope_list li {\n  color: #101010;\n}\n\nbody.light_theme .scope_icon_badge.in_scope {\n  background: rgb(219 134 0 / 10%);\n}\n\nbody.light_theme .scope_icon_badge.out_scope {\n  background: rgb(29 29 29 / 15%);\n}\n\n.scope_list li i {\n  font-size: 16px;\n}\n\n.scope_list li i.in_check {\n  color: #D1AA67;\n}\n\n.scope_list li i.out_cross {\n  color: #64748b;\n}\n\n/* 4. Qualifying Issues Section */\n.qualifying_issues_sec {\n  padding: 20px 0;\n}\n\n.qualifying_issues_sec .sec_subtitle {\n  max-width: 100%;\n}\n\n.qualifying_grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n}\n\n.qualifying_card {\n  width: 59%;\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  padding: 28px 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 150px;\n  transition: all 0.3s ease;\n}\n\n.qualifying_card.activeeffect {\n  width: 39%;\n  background: linear-gradient(90deg, rgba(34, 36, 39, 1) 0%, rgba(82, 73, 56, 1) 170%);\n}\n\nbody.light_theme .qualifying_card {\n  background: rgb(0 0 0 / 5%);\n  border-color: #d7d7d7;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);\n}\n\nbody.light_theme .qualifying_card.activeeffect {\n  background: linear-gradient(90deg, rgb(0 0 0 / 5%) 0%, rgb(209 170 103 / 30%) 170%);\n  border-color: #f3d4d4;\n}\n\n.qualifying_card:hover {\n  border-color: rgba(209, 170, 103, 0.4);\n  transform: translateY(-2px);\n}\n\n.qualifying_card_top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.qualifying_card_subtext {\n  font-size: 21px;\n  color: #D9D9D9;\n  line-height: 1.5;\n  font-weight: 300;\n  margin-bottom: 0;\n  max-width: 70%;\n}\n\nbody.light_theme .qualifying_card_subtext {\n  color: #3c3c3c;\n}\n\nbody.light_theme .qualifying_check_icon {\n  color: #080808;\n}\n\n.qualifying_check_icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: #D1AA67;\n  border: 1px solid #D1AA67;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  min-width: 60px;\n}\n\n.qualifying_card_title {\n  font-size: 40px;\n  font-weight: 300;\n  color: #ffffff;\n  margin-top: 50px;\n  margin-bottom: 20px;\n}\n\nbody.light_theme .qualifying_card_title {\n  color: #111827;\n}\n\n/* 5. Rules of Engagement Section */\n.rules_of_engagement_sec {\n  padding: 110px 0;\n  background-size: cover;\n  background-image: url(../../../../public/images/security-resilience-img/rules_engagementbg.jpg);\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\nbody.light_theme .rules_of_engagement_sec {\n  background-image: none;\n  background-color: #f3f4f6;\n}\n\n.rules_grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 30px;\n}\n\n.rewards_sec .commitment_text {\n  line-height: 1.3;\n}\n\n.rule_pill_card {\n  background: rgba(255, 255, 255, 0.05);\n  -webkit-backdrop-filter: blur(3px);\n  backdrop-filter: blur(3px);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 100px;\n  cursor: pointer;\n  padding: 32px 60px;\n  font-size: 22px;\n  box-shadow: inset 0px 3px 12px rgb(0 0 0 / 30%);\n  color: #E5E7EB;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: all 0.3s ease;\n}\n\nbody.light_theme .rule_pill_card {\n  background: rgb(0 0 0 / 5%);\n  border-color: #cdcdcd;\n  color: #1f2937;\n  box-shadow: inset 0px 3px 12px rgb(0 0 0 / 10%);\n}\n\n.rule_pill_card:hover {\n  border-color: rgba(209, 170, 103, 0.5);\n  color: #D1AA67;\n}\n\n/* 6. Responsible Disclosure & Reporting Section */\n.responsible_disclosure_sec {\n  padding: 90px 0;\n  text-align: center;\n  background-size: cover;\n  background-image: url(../../../../public/images/security-resilience-img/reportingbg.jpg);\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\nbody.light_theme .responsible_disclosure_sec {\n  background-image: url(../../../../public/images/security-resilience-img/reportingbg_light.jpg);\n}\n\n.disclosure_info.listinfo_bl {\n  gap: 48px;\n  border-left: 1px solid rgb(255 255 255 / 40%);\n  border-right: 1px solid rgb(255 255 255 / 40%);\n  padding-left: 32px;\n  padding-right: 32px;\n}\n\n.disclosure_list ul {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.disclosure_list ul li {\n  font-size: 15px;\n  color: #D1D5DB;\n  position: relative;\n  padding-left: 20px;\n  font-weight: 300;\n}\n\n.disclosure_list ul li::before {\n  content: \"\";\n  position: absolute;\n  left: 0px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #D1AA67;\n}\n\n.reporting_steps_row {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 32px;\n  margin-top: 20px;\n  margin-bottom: 60px;\n  justify-content: center;\n}\n\n.reporting_step_item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.reporting_icon_wrap {\n  width: 180px;\n  margin-bottom: 16px;\n}\n\n.reporting_icon_wrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.reporting_step_name {\n  font-size: 24px;\n  font-weight: 500;\n  color: #e9e9e9;\n  margin-bottom: 10px;\n}\n\nbody.light_theme .reporting_step_name {\n  color: #111827;\n}\n\n.reporting_step_desc {\n  font-size: 15px;\n  color: #d7d7d7;\n  line-height: 1.5;\n  max-width: 240px;\n}\n\nbody.light_theme .reporting_step_desc {\n  color: #6b7280;\n}\n\n.disclosure_banner {\n  background: linear-gradient(160deg, rgb(209 170 103 / 20%) 0%, rgba(255, 255, 255, 0) 20%);\n  -webkit-backdrop-filter: blur(3px);\n  backdrop-filter: blur(3);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 20px;\n  padding: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-align: left;\n  box-shadow: inset 0px -7px 16px rgb(255 255 255 / 10%);\n  gap: 20px;\n}\n\nbody.light_theme .disclosure_banner {\n  background: linear-gradient(160deg, rgb(209 170 103 / 20%) 0%, rgb(0 0 0 / 5%) 20%);\n  border-color: #e5e7eb;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);\n}\n\nbody.light_theme .disclosure_info h4 a {\n  color: #303030;\n}\n\nbody.light_theme .disclosure_list ul li {\n  color: #181818;\n}\n\nbody.light_theme .disclosure_btn {\n  color: #000000;\n}\n\n.disclosure_info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.disclosure_info_icon {\n  width: 62px;\n  min-width: 62px;\n  height: 62px;\n  border-radius: 50%;\n  background: rgba(209, 170, 103, 0.15);\n  border: 1px solid rgba(209, 170, 103, 0.4);\n  color: #D1AA67;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n}\n\n.disclosure_info h4 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 4px;\n}\n\n.disclosure_info h4 a {\n  color: #fff;\n}\n\n.disclosure_info h4 span {\n  color: #D1AA67;\n}\n\nbody.light_theme .disclosure_info h4 {\n  color: #111827;\n}\n\n.disclosure_info p {\n  font-size: 15px;\n  color: #9CA3AF;\n  text-align: left;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.disclosure_info.leftinfo_disclosure {\n  width: 440px;\n  max-width: 100%;\n}\n\nbody.light_theme .disclosure_info p {\n  color: #6b7280;\n}\n\n.disclosure_btn {\n  background: #D1AA67;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 500;\n  padding: 15px 32px;\n  box-shadow: 0px 0px 24px rgb(209 170 103 / 50%);\n  border-radius: 30px;\n  text-decoration: none;\n  display: inline-block;\n  white-space: nowrap;\n  transition: all 0.3s ease;\n}\n\n.disclosure_btn:hover {\n  color: #fff;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(209, 170, 103, 0.5);\n}\n\n/* 7. What Happens Next Section */\n.what_happens_next_sec {\n  padding: 50px 0;\n  text-align: center;\n}\n\n.what_happens_next_sec .sec_subtitle {\n  color: #9CA3AF;\n  max-width: 80%;\n}\n\n.what_next_grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 18px;\n  margin-top: 40px;\n}\n\n.next_card {\n  background: none;\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  border: 1px solid #514F4F;\n  position: relative;\n  border-radius: 28px;\n  padding: 14px;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.happens_cardcnt {\n  position: absolute;\n  top: 58px;\n  width: 100%;\n  left: 0px;\n}\n\nbody.light_theme .next_card {\n  background: #ffffff;\n  border-color: #cfcfcf;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);\n}\n\n.next_card:hover {\n  border-color: rgba(209, 170, 103, 0.4);\n  transform: translateY(-4px);\n}\n\n.next_card_icon {\n  width: 124px;\n  margin: 0 auto 36px auto;\n}\n\n.next_card_icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.next_card_title {\n  font-size: 24px;\n  font-weight: 500;\n  color: #ffffff;\n  background: linear-gradient(180deg, #fff 20%, rgb(255 255 255 / 0) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 6px;\n}\n\nbody.light_theme .next_card_title {\n  background: linear-gradient(180deg, #000000 20%, rgb(26 26 26 / 45%) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.next_card_desc {\n  font-size: 14px;\n  font-weight: 300;\n  color: rgb(217 217 217 / 50%);\n  line-height: 1.5;\n  margin: 0;\n  max-width: 80%;\n  margin: 0 auto;\n}\n\nbody.light_theme .next_card_desc {\n  color: #6b7280;\n}\n\n/* 8. Rewards Section */\n.rewards_sec {\n  padding: 110px 0;\n  position: relative;\n  background-size: cover;\n  background-image: url(../../../../public/images/security-resilience-img/rewards_bg.jpg);\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.rewards_sec::before {\n  width: 100%;\n  height: 150px;\n  content: \"\";\n  position: absolute;\n  bottom: 0px;\n  background: linear-gradient(0deg, rgb(23 26 32) 0%, rgba(255, 255, 255, 0) 100%);\n  z-index: 1;\n}\n\n.rewards_sec .container {\n  position: relative;\n  z-index: 222;\n}\n\nbody.light_theme .rewards_sec {\n  background-image: url(../../../../public/images/security-resilience-img/rewards_bg_light.jpg);\n  background-color: #ffffff;\n}\n\nbody.light_theme .rewards_sec::before {\n  background: linear-gradient(0deg, rgb(255 255 255) 0%, rgba(255, 255, 255, 0) 100%);\n}\n\n.rewards_callout_box {\n  background: rgb(255 255 255 / 15%);\n  border: 1px solid rgb(255 255 255 / 30%);\n  border-radius: 50px;\n  padding: 16px 20px;\n  margin-top: 24px;\n  font-weight: 300;\n  font-size: 20px;\n  color: #fff;\n  line-height: 1.5;\n  display: flex;\n  align-items: start;\n  gap: 12px;\n}\n\n.rewards_callout_box .ri-information-fill:before {\n  color: #897c47;\n  font-size: 22px;\n}\n\nbody.light_theme .rewards_callout_box {\n  background: rgb(0 0 0 / 12%);\n  color: #000000;\n}\n\n.rewards_card {\n  margin-left: 18px;\n  background: rgba(255, 255, 255, 0.10);\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n  border: 1px solid rgba(255, 255, 255, 0.20);\n  border-radius: 16px;\n  padding: 0px;\n}\n\nbody.light_theme .rewards_callout_box .ri-information-fill:before {\n  color: #bbb087;\n}\n\nbody.light_theme .rewards_card {\n  background: rgb(255 255 255 / 10%);\n  border-color: #e5e7eb;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10);\n}\n\nbody.light_theme .reward_val {\n  color: #000000;\n}\n\n.reward_row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 26px;\n  border-bottom: 1px solid rgb(255 255 255 / 10%);\n}\n\nbody.light_theme .reward_row {\n  border-bottom-color: #cfcfcf;\n}\n\n.reward_row:last-child {\n  border-bottom: none;\n}\n\n.reward_level {\n  font-size: 16px;\n  font-weight: 400;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.rangelevel span {\n  font-size: 14px;\n  color: #9CA3AF;\n}\n\n.reward_level i {\n  font-size: 12px;\n  color: #10B981;\n}\n\n.reward_level i.critical:before {\n  color: #EF4444;\n}\n\n.reward_level i.high:before {\n  color: #F59E0B;\n}\n\n.reward_level i.medium:before {\n  color: #D1AA67;\n}\n\n.reward_level i.information:before {\n  color: #9CA3AF;\n}\n\nbody.light_theme .reward_level {\n  color: #111827;\n}\n\n.reward_val {\n  font-size: 16px;\n  font-weight: 300;\n  color: #E5E7EB;\n}\n\nspan.reward_val.dangercolor {\n  color: #d1aa67;\n}\n\n/* 9. Safe Harbor Section */\n.safe_harbor_sec {\n  padding: 90px 0;\n}\n\n.safe_harbor_main_card {\n  background: rgba(255, 255, 255, 0.05);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  padding: 32px;\n  display: grid;\n  grid-template-columns: 1fr 440px;\n  gap: 40px;\n  align-items: center;\n  margin-bottom: 60px;\n  box-shadow: inset 0 6px 20px rgb(0 0 0 / 20%);\n}\n\n.safe_harbor_main_card::before {\n  width: 384px;\n  height: 384px;\n  position: absolute;\n  content: \"\";\n  top: -110px;\n  right: -70px;\n  background: rgb(209 170 103 / 10%);\n  border-radius: 100%;\n  filter: blur(30px);\n}\n\nbody.light_theme .safe_harbor_main_card {\n  background: rgb(0 0 0 / 5%);\n  border-color: #e5e7eb;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);\n}\n\n/* .safe_harbor_title {\n  color: #ffffff;\n  margin-bottom: 15px;\n  line-height: 1.15;\n} */\n\nbody.light_theme .safe_harbor_title {\n  color: #111827;\n}\n\n.safe_harbor_desc {\n  font-size: 24px;\n  color: #9CA3AF;\n  line-height: 1.40;\n  margin: 0;\n  font-weight: 300;\n}\n\nbody.light_theme .safe_harbor_desc {\n  color: #4b5563;\n}\n\n.safe_harbor_notice_card {\n  background: rgba(255, 255, 255, 0.10);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  position: relative;\n  z-index: 222;\n  border-radius: 16px;\n  padding: 18px;\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\nbody.light_theme .safe_harbor_notice_card {\n  background: rgba(0, 0, 0, 0.10);\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.safe_notice_icon {\n  color: #D1AA67;\n  font-size: 20px;\n}\n\n.safe_notice_text {\n  font-size: 14px;\n  color: #CBD5E1;\n  line-height: 1.55;\n  margin: 0;\n  font-weight: 300;\n}\n\nbody.light_theme .safe_notice_text {\n  color: #6b7280;\n}\n\n.safe_harbor_bottom_grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  padding-top: 20px;\n}\n\n.safe_mini_card {\n  background: rgba(255, 255, 255, 0.10);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  padding: 24px;\n  display: flex;\n  box-shadow: inset 0 6px 20px rgb(0 0 0 / 25%);\n  align-items: center;\n  gap: 18px;\n}\n\nbody.light_theme .safe_mini_card {\n  background: rgb(0 0 0 / 5%);\n  border-color: #e5e7eb;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);\n}\n\n.safe_mini_icon {\n  width: 56px;\n  height: 56px;\n  min-width: 56px;\n  border-radius: 50%;\n  border: 1px solid rgb(212 175 55 / 40%);\n  /* background: rgba(209, 170, 103, 0.05); */\n  box-shadow: 0px 0px 14px rgb(212 175 55 / 25%);\n  color: #F5D77F;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n\n.safe_mini_content {\n  display: flex;\n  flex-direction: column;\n}\n\n.safe_mini_title {\n  font-size: 17px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0 0 6px 0;\n  line-height: 1.3;\n}\n\nbody.light_theme .safe_mini_title {\n  color: #111827;\n}\n\nh4.safe_mini_title.questionshd {\n  font-size: 21px;\n}\n\n.safe_mini_desc {\n  font-size: 14px;\n  color: #CBD5E1;\n  line-height: 1.5;\n  margin: 0;\n  font-weight: 300;\n}\n\nbody.light_theme .what_happens_next_sec {\n  background-color: #fff;\n}\n\nbody.light_theme .safe_mini_desc {\n  color: #000;\n}\n\nbody.light_theme .safe_mini_icon {\n  color: #d1aa67;\n}\n\n.safe_harbor_left {\n  position: relative;\n  z-index: 222;\n}\n\n@media (max-width: 1640px) {\n\n  .sec_title {\n    font-size: 62px;\n  }\n\n  .our_commitment_sec .sec_title {\n    font-size: 60px;\n  }\n\n}\n\n@media (max-width: 1440px) {\n\n  .sec_title {\n    font-size: 54px;\n  }\n\n  .happens_cardcnt {\n    top: 48px;\n  }\n\n  .next_card_title {\n    font-size: 21px;\n  }\n\n  .next_card_icon {\n    width: 100px;\n    margin: 0 auto 24px auto;\n  }\n\n  .our_commitment_sec .sec_title {\n    font-size: 54px;\n  }\n\n  .commitment_text {\n    font-size: 22px;\n  }\n\n  .sec_title.h2titlesope {\n    font-size: 48px;\n  }\n\n  .sec_subtitle {\n    font-size: 20px;\n  }\n\n  .qualifying_card_title {\n    font-size: 36px;\n  }\n\n}\n\n@media (max-width:1376px) {\n\n  .sec_title {\n    font-size: 48px;\n  }\n\n  .safe_harbor_desc {\n    font-size: 18px;\n  }\n\n  .security_resilience_hero_sec .sec_subtitle {\n    font-size: 20px;\n  }\n\n  .hero_img_wrap {\n    margin-top: -65px;\n  }\n\n  .hero_img_wrap img {\n    max-width: 80%;\n  }\n\n  .our_commitment_sec .sec_title {\n    font-size: 42px;\n  }\n\n  .commitment_text {\n    font-size: 18px;\n  }\n\n  .sec_title.h2titlesope {\n    font-size: 40px;\n  }\n\n  .sec_subtitle {\n    font-size: 18px;\n  }\n\n  .scope_card_title {\n    font-size: 28px;\n  }\n\n  .scope_list li {\n    font-size: 16px;\n  }\n\n  .qualifying_card_subtext {\n    font-size: 16px;\n  }\n\n  .qualifying_card_title {\n    font-size: 28px;\n  }\n\n  .qualifying_card {\n    width: 58%;\n  }\n\n  .rule_pill_card {\n    padding: 24px 42px;\n    font-size: 18px;\n  }\n\n  .reporting_step_name {\n    font-size: 20px;\n  }\n\n  .rewards_callout_box {\n    font-size: 16px;\n  }\n\n\n}\n\n/* Media Queries */\n@media (max-width: 1200px) {\n\n\n  .security_resilience_hero_sec {\n    padding-top: 60px;\n  }\n\n  .herobnr_btn button {\n    font-size: 15px;\n    padding: 15px 32px;\n  }\n\n  .hero_img_wrap {\n    margin-top: -35px;\n  }\n\n  .our_commitment_sec .sec_title {\n    font-size: 32px;\n  }\n\n  .commitment_text {\n    font-size: 16px;\n  }\n\n  .sec_subtitle {\n    font-size: 16px;\n  }\n\n  .scope_card {\n    padding: 32px;\n  }\n\n  .scope_icon_badge {\n    width: 60px;\n    height: 60px;\n    min-width: 60px;\n    font-size: 30px;\n  }\n\n  .qualifying_card_title {\n    font-size: 24px;\n  }\n\n  .rule_pill_card {\n    padding: 20px 36px;\n    font-size: 16px;\n  }\n\n  .disclosure_info.leftinfo_disclosure {\n    flex-direction: column;\n    align-items: start;\n  }\n\n  .disclosure_btn {\n    font-size: 15px;\n    padding: 12px 28px;\n  }\n\n\n  .disclosure_info.listinfo_bl {\n    gap: 32px;\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n\n  .scope_sec {\n    padding: 50px 0;\n  }\n\n  .rules_of_engagement_sec {\n    padding: 60px 0;\n  }\n\n  .responsible_disclosure_sec {\n    padding: 60px 0;\n  }\n\n  .rewards_sec {\n    padding: 70px 0;\n  }\n\n  .reward_val {\n    font-size: 15px;\n    text-align: right;\n  }\n\n  .reward_level {\n    font-size: 14px;\n  }\n\n  .sec_title.h2titlesope {\n    font-size: 32px;\n  }\n\n  .sec_title {\n    font-size: 34px;\n  }\n\n  .reporting_steps_row,\n  .what_next_grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 991px) {\n\n  .sec_title {\n    font-size: 32px;\n  }\n\n  .security_resilience_hero_sec .sec_subtitle {\n    font-size: 18px;\n  }\n\n  .hero_img_wrap {\n    margin-top: -15px;\n  }\n\n  .our_commitment_sec .sec_title {\n    font-size: 28px;\n  }\n\n  .commitment_text {\n    font-size: 15px;\n  }\n\n  .sec_title.h2titlesope {\n    font-size: 28px;\n  }\n\n  .sec_subtitle {\n    font-size: 15px;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n\n  .scope_grid,\n  .qualifying_grid,\n  .rules_grid,\n  .safe_harbor_main_card {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .safe_harbor_bottom_grid {\n    grid-template-columns: 1fr;\n  }\n\n  .disclosure_banner {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .disclosure_info {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .qualifying_card.activeeffect {\n    width: 100%;\n  }\n\n  .qualifying_card {\n    width: 100%;\n  }\n\n  .rules_of_engagement_sec {\n    padding: 40px 0;\n  }\n\n  .responsible_disclosure_sec {\n    padding: 40px 0;\n  }\n\n  .disclosure_info.leftinfo_disclosure {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .disclosure_info h4 {\n    text-align: left;\n  }\n\n  .disclosure_info.leftinfo_disclosure {\n    width: 100%;\n  }\n\n  .disclosure_info.listinfo_bl {\n    gap: 12px;\n    padding-left: 0px;\n    padding-right: 0px;\n    width: 100%;\n    align-items: start;\n    border: none;\n  }\n\n  .disclosure_list ul li {\n    text-align: left;\n  }\n\n  .disclosure_banner {\n    padding: 32px;\n    align-items: start;\n    text-align: left;\n    gap: 32px;\n  }\n\n  .what_happens_next_sec {\n    padding: 20px 0 40px;\n  }\n\n  .rewards_sec {\n    padding: 40px 0;\n  }\n\n  .rewards_card {\n    margin-left: 0px;\n    margin-top: 15px;\n  }\n\n  .safe_harbor_sec {\n    padding: 40px 0;\n  }\n\n  .safe_harbor_desc {\n    font-size: 15px;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .security_resilience_hero_sec {\n    padding-top: 50px;\n    padding-bottom: 0px;\n  }\n\n  .reporting_steps_row {\n    margin-top: 0px;\n    gap: 18px;\n    margin-bottom: 30px;\n  }\n\n  h4.safe_mini_title.questionshd {\n    font-size: 18px;\n  }\n\n  .bugbounty_page {\n    padding-bottom: 20px;\n  }\n\n  .safe_harbor_main_card {\n    margin-bottom: 18px;\n  }\n\n  .sec_title {\n    font-size: 24px;\n  }\n\n  .security_resilience_hero_sec .sec_subtitle {\n    font-size: 15px;\n    padding-top: 0px;\n  }\n\n  .herobnr_btn button {\n    font-size: 14px;\n    padding: 10px 24px;\n  }\n\n  .herobnr_btn {\n    gap: 15px;\n  }\n\n  .hero_img_wrap {\n    margin-top: 0px;\n  }\n\n  .sec_subtitle {\n    font-size: 14px;\n  }\n\n  .reporting_steps_row,\n  .what_next_grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .hero_img_wrap img {\n    max-width: 100%;\n  }\n\n  .our_commitment_sec .sec_title {\n    font-size: 22px;\n  }\n\n  .commitment_img_wrap img {\n    max-height: 280px;\n  }\n\n  .sec_title.h2titlesope {\n    font-size: 22px;\n  }\n\n  .scope_sec {\n    padding: 30px 0;\n  }\n\n  .scope_card {\n    padding: 26px;\n  }\n\n  .scope_icon_badge {\n    width: 42px;\n    height: 42px;\n    min-width: 42px;\n    font-size: 22px;\n  }\n\n  .scope_icon_badge.in_scope {\n    border: 1.7px solid #D1AA67;\n  }\n\n  .scope_card_title {\n    font-size: 22px;\n  }\n\n  .scope_list li {\n    font-size: 14px;\n    padding-left: 24px;\n  }\n\n  .scope_icon_badge.out_scope {\n    border: 1.7px solid #999999;\n  }\n\n  .qualifying_card_subtext {\n    font-size: 15px;\n  }\n\n  .qualifying_card {\n    padding: 22px;\n  }\n\n  .qualifying_card_title {\n    font-size: 20px;\n    margin-bottom: 0px;\n  }\n\n  .qualifying_check_icon {\n    width: 36px;\n    height: 36px;\n    font-size: 17px;\n    min-width: 36px;\n  }\n\n  .rule_pill_card {\n    padding: 12px 24px;\n    font-size: 15px;\n  }\n\n  .reporting_step_desc {\n    max-width: 320px;\n  }\n\n  .disclosure_banner {\n    padding: 22px;\n  }\n\n  .disclosure_info p {\n    font-size: 13px;\n  }\n\n  .disclosure_info_icon {\n    width: 42px;\n    min-width: 42px;\n    height: 42px;\n    font-size: 15px;\n  }\n\n  .what_happens_next_sec .sec_subtitle {\n    max-width: 100%;\n  }\n\n  .responsible_disclosure_sec {\n    padding: 30px 0 24px;\n  }\n\n  .what_next_grid {\n    margin-top: 28px;\n  }\n\n  .rewards_callout_box {\n    font-size: 15px;\n  }\n\n  .reward_row {\n    padding: 12px 18px;\n  }\n\n  .reward_val {\n    font-size: 13px;\n  }\n\n  .safe_harbor_sec {\n    padding: 20px 0;\n  }\n\n  .safe_harbor_main_card {\n    padding: 24px;\n  }\n\n\n}\n\n@media (max-width: 480px) {\n\n  .reporting_steps_row,\n  .what_next_grid {\n    grid-template-columns: 1fr;\n  }\n\n  .herobnr_btn button {\n    padding: 9px 18px;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
